export class Productconfgroup {
    productid:number
    confgroupid:number

    constructor(productid:number,confgorupid:number){
        this.productid=productid;
        this.confgroupid=confgorupid;
    }
}
